module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-side-menu"
  }, [(_vm.isAdmin) ? _c('el-menu', {
    staticClass: "menu collapse-menu",
    attrs: {
      "default-active": _vm.$route.path,
      "router": "router",
      "collapse": _vm.isCollapse,
      "background-color": _vm.backgroundColor,
      "text-color": _vm.textColor,
      "active-text-color": _vm.activeTextColor
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/admin"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("待办事项")])]), _c('el-submenu', {
    attrs: {
      "index": "account"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-id-card-o"
  }), _c('span', [_vm._v("账号模块")])]), _c('el-menu-item-group', [_c('el-menu-item', {
    attrs: {
      "index": "/admin/orgs"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("成员管理")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/experts"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("专家管理")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/users"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("用户管理")])])], 1)], 2), _c('el-submenu', {
    attrs: {
      "index": "resource"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-database"
  }), _c('span', [_vm._v("资源模块")])]), _c('el-menu-item-group', [_c('el-menu-item', {
    attrs: {
      "index": "/admin/notifications"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("通知管理")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/templates"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("模板管理")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/materials"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("资源管理")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/medias"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("媒体管理")])])], 1)], 2), _c('el-submenu', {
    attrs: {
      "index": "meeting"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _c('span', [_vm._v("培训室管理")])]), _c('el-menu-item-group', [_c('el-menu-item', {
    attrs: {
      "index": "/admin/meeting"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("预约首页")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/meeting/reserve"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("预约管理")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/meeting/agendas"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("会议议程")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/meeting/appointments?state=activates"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("预约列表")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/meeting/appointments?state=histories"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("预约历史")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/meeting/rooms"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("培训室设置")])])], 1)], 2), _c('el-submenu', {
    attrs: {
      "index": "research"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-joomla"
  }), _c('span', [_vm._v("教改项目")])]), _c('el-menu-item-group', [_c('el-menu-item', {
    attrs: {
      "index": "/admin/research/activities"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("教改管理")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/research/catalogs"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("经费类型")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/research/funds"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("经费报销管理")])])], 1)], 2), _c('el-submenu', {
    attrs: {
      "index": "activities"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-trophy"
  }), _c('span', [_vm._v("比赛管理")])]), _c('el-menu-item-group', [_c('el-menu-item', {
    attrs: {
      "index": "/admin/compete/activities"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("比赛管理")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/stat/orgs"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("比赛排行")])])], 1)], 2), _c('el-menu-item', {
    attrs: {
      "index": "/admin/train/activities"
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _c('span', [_vm._v("培训管理")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/helpCenter"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  }), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("帮助中心")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/layouts"
    }
  }, [_c('i', {
    staticClass: "fa fa-indent"
  }), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("模板布局管理")])])], 1) : _c('el-menu', {
    staticClass: "menu collapse-menu",
    attrs: {
      "default-active": _vm.$route.path,
      "router": "router",
      "collapse": _vm.isCollapse,
      "background-color": _vm.backgroundColor,
      "text-color": _vm.textColor,
      "active-text-color": _vm.activeTextColor
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/admin"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("待办事项")])]), (_vm.isRole('meeting')) ? _c('el-submenu', {
    attrs: {
      "index": "meeting"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _c('span', [_vm._v("培训室管理")])]), _c('el-menu-item-group', [_c('el-menu-item', {
    attrs: {
      "index": "/admin/meeting"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("预约首页")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/meeting/reserve"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("预约管理")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/meeting/agendas"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("会议议程")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/meeting/appointments?state=activates"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("预约列表")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/meeting/appointments?state=histories"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("预约历史")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/meeting/rooms"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("培训室设置")])])], 1)], 2) : _vm._e(), (_vm.isRole('research')) ? _c('el-submenu', {
    attrs: {
      "index": "research"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _c('span', [_vm._v("教改项目")])]), _c('el-menu-item-group', [_c('el-menu-item', {
    attrs: {
      "index": "/admin/research/activities"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("教改管理")])]), _c('el-menu-item', {
    attrs: {
      "index": "/admin/research/catalogs"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _c('span', [_vm._v("经费类型")])])], 1)], 2) : _vm._e(), (_vm.isRole('expense')) ? _c('el-menu-item', {
    attrs: {
      "index": "/admin/research/funds"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _c('span', [_vm._v("经费报销管理")])]) : _vm._e(), (_vm.isRole('compete')) ? _c('el-menu-item', {
    attrs: {
      "index": "/admin/compete/activities"
    }
  }, [_c('i', {
    staticClass: "fa fa-trophy"
  }), _c('span', [_vm._v("比赛管理")])]) : _vm._e(), (_vm.isRole('train')) ? _c('el-menu-item', {
    attrs: {
      "index": "/admin/trains"
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _c('span', [_vm._v("培训管理")])]) : _vm._e(), _c('el-menu-item', {
    attrs: {
      "index": "/admin/helpCenter"
    }
  }, [_c('i', {
    staticClass: "fa fa-indent"
  }), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("帮助中心")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa641cce","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Sidebar.vue
// module id = 581
// module chunks = 85